import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * SalesCallClosing — vékony route-wrapper.
 *
 * A Sales beszélgetés TELJES flow (setup + generálás + result) a
 * `SalesAgent` komponensben fut (`ConversionAgents.js`), amit a
 * `/agents/sales` route renderel. A `/agents/sales-call-closing` route
 * kizárólag `?resume_job=…` átirányításra szolgál — átdobja a paramot
 * a Sales route-ra, ahol a resume-logika lefut.
 */
export default function SalesCallClosing() {
  const navigate = useNavigate();
  useEffect(() => {
    const url = new URL(window.location.href);
    const resumeJob = url.searchParams.get("resume_job");
    const dest = resumeJob ? `/agents/sales?resume_job=${resumeJob}` : "/agents/sales";
    navigate(dest, { replace: true });
  }, [navigate]);
  return null;
}
